module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.locked ? "action-list locked" : "action-list"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "cols s_24"
  }, [(!_vm.items.length) ? [_vm._v("\n\t\t\t\t" + _vm._s(_vm.data.nothing_to_show) + "\n\t\t\t")] : [_c('ul', {
    staticClass: "grid s_1 m_2 l_3"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', [_c('div', {
      staticClass: "item"
    }, [_c('a', {
      staticClass: "imgContainer",
      style: (("background-image: url(" + (item.image_src) + ")")),
      attrs: {
        "href": item.href
      }
    }, [_c('p', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data))]), _vm._v(" "), _c('p', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.text))])])])])
  }), 0)]], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-683c3ab5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/lists/default.vue
// module id = 272
// module chunks = 37